import React from 'react';
import { LockOutlined } from '@ant-design/icons';
import { Button, Space, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FeatureKey } from '../../../constants/features';

interface Props {
  featureKey?: FeatureKey;
  /** インライン（省スペース）表示にする場合 true */
  inline?: boolean;
}

/**
 * プラン外機能のロック表示。鍵アイコン＋「ライトプランで利用可能」＋アップグレード導線。
 */
export const LockedFeature: React.FC<Props> = ({ featureKey, inline }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const label = featureKey ? t(`featureLabel.${featureKey}`) : t('locked.thisFeature');

  if (inline) {
    return (
      <Space size={4}>
        <LockOutlined style={{ color: '#bfbfbf' }} />
        <Typography.Text type="secondary">{t('locked.availableInline')}</Typography.Text>
        <Button type="link" size="small" onClick={() => navigate('/plan')}>
          {t('locked.upgradeShort')}
        </Button>
      </Space>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
        border: '1px dashed #d9d9d9',
        borderRadius: 8,
        background: '#fafafa',
        gap: 8,
      }}
    >
      <LockOutlined style={{ fontSize: 32, color: '#bfbfbf' }} />
      <Typography.Text strong>{t('locked.availableIn', { label })}</Typography.Text>
      <Typography.Text type="secondary">{t('locked.upgradeDesc')}</Typography.Text>
      <Button type="primary" onClick={() => navigate('/plan')}>
        {t('locked.upgradeAction')}
      </Button>
    </div>
  );
};
